"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsArray_1 = __importDefault(require("../../typeAssertions/valueIsArray"));
const valueIsNullOrUndef_1 = __importDefault(require("../../typeAssertions/valueIsNullOrUndef"));
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const isUndefinedBuilder = () => ({ entryVars: { valueToTest }, callbacks, executeProcesses, }) => {
    const condition = (0, valueIsNullOrUndef_1.default)(valueToTest)
        || (valueToTest === 0)
        || (valueToTest === false)
        || (valueToTest === '')
        || ((0, valueIsRecord_1.default)(valueToTest) && !Object.keys(valueToTest).length)
        || ((0, valueIsArray_1.default)(valueToTest) && !valueToTest.length)
        || (Number.isNaN(valueToTest));
    if (condition) {
        executeProcesses(undefined, callbacks.successProcess);
        return true;
    }
    executeProcesses(undefined, callbacks.errorProcess);
    return false;
};
exports.default = isUndefinedBuilder;
